<main class="unavailable-container" role="main">
  <div
    class="unavailable-content"
    role="alert"
    aria-live="polite"
    tabindex="0"
  >
    <div class="icon-container" aria-hidden="true">
      <mat-icon class="warning-icon">cloud_off</mat-icon>
    </div>

    <h1 class="title" id="unavailable-title">
      {{ 'SERVICE_UNAVAILABLE.TITLE' | translate }}
    </h1>

    <p class="message" id="unavailable-message">
      {{ 'SERVICE_UNAVAILABLE.MESSAGE' | translate }}
    </p>

    <div class="actions">
      <button
        mat-raised-button
        color="primary"
        (click)="retry()"
        aria-describedby="unavailable-message"
        class="retry-button"
      >
        {{ 'SERVICE_UNAVAILABLE.RETRY' | translate }}
      </button>

      <button
        mat-stroked-button
        (click)="goHome()"
        class="home-button"
      >
        {{ 'SERVICE_UNAVAILABLE.GO_HOME' | translate }}
      </button>
    </div>
  </div>
</main>
